<template>
  <div>
    <Main />
  </div>
</template>

<script>
import Main from "../../canadas/terrenos/maplocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
};
</script>
